import { render, staticRenderFns } from "./ApiDocument.vue?vue&type=template&id=5a622d75&"
import script from "./ApiDocument.vue?vue&type=script&lang=js&"
export * from "./ApiDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports